import type { AxiosInstance } from "axios";
import { API_URL } from "~/env";
import { sendRequest } from "~/utils/axios-utils";

// orlando: 替换掉了nuxt2里面的网络部分
// 同api一样，采用了plugin中，集中配置网络
export default ($axios: AxiosInstance) => {
  // 设置 baseURL
  // 注意：这里我们使用 defaults.baseURL 而不是 setBaseURL 方法
  if (process.env.NODE_ENV === "development") {
    $axios.defaults.baseURL = API_URL;
  }

  return {
    /**
     * GET请求
     */
    get: (url: string, params: any) => sendRequest($axios, { method: "GET", url, params }),
    /**
     * POST请求
     */
    post: (url: string, params: any) => sendRequest($axios, { method: "POST", url, data: params }),
  };
};
